__turbopack_context__.v({
  "showcase": "CaseStudyShowcase-module-scss-module__t93i2a__showcase",
  "stack": "CaseStudyShowcase-module-scss-module__t93i2a__stack",
});
